export default "__VITE_ASSET__a08a26b8__"